/* KUTEE' scroll reveals — slow fade/translate-up on section entry.
   Classes are applied BY this script, so if JS never runs nothing is
   ever hidden. Skipped entirely under prefers-reduced-motion. */
(() => {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!('IntersectionObserver' in window)) return;

  const SELECTOR = [
    '.ku-icon-bar__item',
    '.ku-iwt__text',
    '.ku-iwt__cta',
    '.ku-lifestyle-tile__content',
    '.ku-featured__header',
    '.ku-featured__track .ku-card',
    '.ku-faq__item',
    '.ku-quote__inner',
  ].join(', ');

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('ku-reveal--in');
          observer.unobserve(entry.target);
        }
      });
    },
    { rootMargin: '0px 0px -8% 0px', threshold: 0.1 }
  );

  const prime = () => {
    document.querySelectorAll(SELECTOR).forEach((el, i) => {
      if (el.classList.contains('ku-reveal')) return;
      // Don't hide elements already in the viewport on load (no pop-in).
      const rect = el.getBoundingClientRect();
      if (rect.top < window.innerHeight * 0.9) return;
      el.classList.add('ku-reveal');
      el.style.setProperty('--ku-reveal-delay', `${(i % 4) * 70}ms`);
      observer.observe(el);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', prime);
  } else {
    prime();
  }
  document.addEventListener('shopify:section:load', prime);
})();
